var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticStyle: {
      "margin-top": "75px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t员工入职-详情")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 40px 0 40px",
      "height": "800px",
      "background-color": "#FFFFFF"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.staff_name))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.staff_gender))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("身份证号码：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.staff_card))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.staff_telephone))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("本人照片：")]), _vm._v(" "), _c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.ruleForm.staff.staff_photo
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("身份证原件照片：")]), _vm._v(" "), _c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.ruleForm.staff.card_photo
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("银行卡号：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.bank_no))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("开户行：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.bankName))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("银行卡照片：")]), _vm._v(" "), _c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.ruleForm.staff.bank_photo
    }
  })], 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("组织架构：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.range))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("城市：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.city_id))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("职位：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.post_name))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("入职薪酬：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.induction_salary))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("入职日期：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.induction_time))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("是否有试用期：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.is_trial == '1' ? '是' : '否'))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("试用期时间：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.trial_start + "至" + _vm.ruleForm.trial_end))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("试用期薪资：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.induction_salary))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v(" 入职添加日期：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.induction_date))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("签约合同上传：")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', _vm._l((_vm.fileList), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticStyle: {
        "width": "90%",
        "border": "1px solid #e9e9e9",
        "border-radius": "5px",
        "padding": "0 10px",
        "height": "100px"
      }
    }, [_c('el-row', [_c('el-col', {
      staticStyle: {
        "margin": "13px 0px"
      },
      attrs: {
        "span": 6
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/icon/文件类型-附件@2x.png"),
        "width": "65px",
        "height": "73px"
      }
    })]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "30px 0px"
      },
      attrs: {
        "span": 12
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin": "36px 0px"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-button', {
      staticStyle: {
        "background-color": "#006E4B",
        "color": "#FFFFFF",
        "border": "1px solid #006E4B"
      },
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t下载附件")])], 1)], 1)], 1)])
  }), 1)], 1)], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-left": "3px #006E48 solid",
      "margin-left": "5%",
      "border-bottom": "1px #f8f8f8 solid",
      "margin-right": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("基础信息")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-left": "3px #006E48 solid",
      "margin-top": "60px",
      "margin-left": "5%",
      "border-bottom": "1px #f8f8f8 solid",
      "margin-right": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("入职信息")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9febb066","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ygrz/Ygrz_edit.vue
// module id = null
// module chunks = 